// extracted by mini-css-extract-plugin
export default {"HighlightsRounded":"ProfileContent_HighlightsRounded__U7vzO"};